export const HighlightText = ({ content }) => {
  if (!content) return null;

  // This regex splits the string into parts, keeping the *text* as its own item
  const parts = content.split(/(\*.*?\*)/g);

  return (
    <>
      {parts.map((part, index) => {
        if (part.startsWith('*') && part.endsWith('*')) {
          // Remove asterisks and wrap in a span
          const highlightContent = part.slice(1, -1);
          return (
            <span key={index} className="highlight-text">
              {highlightContent}
            </span>
          );
        }
        return part; // Return normal text as is
      })}
    </>
  );
};